<!-- BL du dossier : liens vers la planification (fenêtre de livraison location), le BL signé et le board des tournées ; jamais tout l'historique. Repliée à l'arrivée. -->
<div class="table-card">
  <div class="table-header-bar">
    <button type="button" class="fold" [attr.aria-expanded]="!folded" (click)="folded = !folded" [matTooltip]="folded ? 'Déplier les BL du dossier' : 'Replier les BL du dossier'">
      <mat-icon>{{ folded ? 'expand_more' : 'expand_less' }}</mat-icon>
      <span class="table-title"><mat-icon>local_shipping</mat-icon><span>BL du dossier</span>
        @if (dels !== null && !failed) { <span class="muted">{{ countLabel }}</span> } @else { <span class="muted">non signés, et signés depuis {{ signedDays }} jours</span> }
      </span>
    </button>
    @if (loading) {
      <mat-progress-spinner mode="indeterminate" diameter="14" strokeWidth="2" color="primary" aria-label="BL en cours de lecture"></mat-progress-spinner>
    }
  </div>

  @if (!folded) {
    @if (failed) {
      <div class="empty small error">Lecture des BL en échec : {{ failed }} · <button type="button" class="link-btn" (click)="read()">Réessayer</button></div>
    } @else if (dels === null) {
      <div class="empty small">Lecture des BL du dossier…</div>
    } @else {
      <div class="bls-grid">
        <div class="line entete">
          <div class="cell">BL</div>
          <div class="cell">Jour</div>
          <div class="cell">Contenu</div>
          <div class="cell">Patients</div>
          <div class="cell">Tournée</div>
          <div class="cell">Liens</div>
        </div>

        <div class="group-head"><span class="group-title">Planifiés, pas encore signés</span><span class="group-count">{{ open.length }}</span></div>
        @for (b of open; track b.id) {
          <ng-container *ngTemplateOutlet="row; context: { $implicit: b }"></ng-container>
        } @empty {
          <div class="none">Aucun BL planifié en attente de signature.</div>
        }

        <div class="group-head"><span class="group-title">Signés depuis {{ signedDays }} jours</span><span class="group-count">{{ signed.length }}</span></div>
        @for (b of signed; track b.id) {
          <ng-container *ngTemplateOutlet="row; context: { $implicit: b }"></ng-container>
        } @empty {
          <div class="none">Aucun BL signé depuis {{ signedDays }} jours.</div>
        }
      </div>
      @if (truncated) {
        <div class="note">Lecture limitée aux 100 derniers BL du dossier : des BL de la période peuvent manquer.</div>
      }
    }
  }
</div>

<ng-template #row let-b>
  <div class="line" [class.is-signed]="b.signed">
    <div class="cell bl-id">BL {{ b.id }}</div>
    <div class="cell date-cell">
      @if (b.signed) { signé le {{ b.signedAt | tzdate: 'DD/MM/YYYY' }} à {{ b.signedAt | tzdate: 'HH:mm' }} }
      @else if (b.day) { prévu le {{ frDay(b.day) }}@if (halfLabel(b)) { · {{ halfLabel(b) }} } }
      @else { <span class="muted">date à fixer</span> }
    </div>
    <div class="cell" [matTooltip]="b.what.includes('matériel repris') ? 'Cochez « Matériel récupéré non facturé » ou « Matériel clos » pour lire ces lignes et leurs patients' : ''">{{ b.what }}</div>
    <div class="cell">@if (b.patients) { {{ b.patients }} } @else { <span class="faint">—</span> }</div>
    <div class="cell muted">{{ runLabel(b) }}</div>
    <div class="cell links">
      <button type="button" class="link-btn" (click)="openBl.emit(b.id)" [matTooltip]="b.signed ? 'Fenêtre de livraison location, BL en lecture seule' : 'Fenêtre de livraison location : planifier, imprimer, signer'">Accéder à la planification</button>
      @if (b.signedPdf) {
        <a class="link-btn" [routerLink]="['/d/bl', b.id]" target="_blank" matTooltip="PDF du BL signé (nouvel onglet)">Ouvrir le BL signé</a>
      } @else {
        <span class="link-btn off" aria-disabled="true" [matTooltip]="signedOffTip(b)">Ouvrir le BL signé</span>
      }
      @if (b.planning) {
        <a class="link-btn" [routerLink]="b.planning" [queryParams]="{ bl: b.id }" target="_blank" matTooltip="Board des tournées de ce jour, BL encadré (nouvel onglet)">Voir dans la tournée</a>
      } @else {
        <span class="link-btn off" aria-disabled="true" [matTooltip]="boardOffTip(b)">Voir dans la tournée</span>
      }
    </div>
  </div>
</ng-template>
